
const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1 className="text-3xl font-bold text-red-600">⛔ Accès refusé</h1>
    </div>
  );
};

export default Unauthorized;
